import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CueUserWarning } from 'src/app/models/fincas/cue.model';

/** Shows user-actionable warnings before the technical details. */
@Component({
  selector: 'app-cue-user-warnings',
  templateUrl: './cue-user-warnings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CueUserWarningsComponent {
  @Input({ required: true })
  public warnings: CueUserWarning[] = [];

  @Input()
  public hasPendingCue = false;

  @Input()
  public pendingTaskCount = 0;

  public get hasWarnings(): boolean {
    return this.warnings.length > 0;
  }

  public get emptyMessage(): string {
    if (this.hasPendingCue) {
      return 'No tienes que corregir datos ahora. El cuaderno ya está enviado y solo falta recibir la respuesta.';
    }

    if (this.pendingTaskCount > 0) {
      return 'No hay avisos bloqueantes detectados antes del envío.';
    }

    return 'Cuando haya actividades preparadas, aquí aparecerán los datos que convenga revisar antes de enviar.';
  }
}
